import { useTranslation } from 'react-i18next';
import { LoadingIndicator } from '../../../../common/components/LoadingIndicator.tsx';
import { DialogHeader, DialogTitle } from '../../../../common/components/ui/dialog.tsx';

export function CartDialogCopyExistingOrder({ source }: Readonly<{ source: 'order' | 'template' | 'salesorderset' }>) {
  const { t } = useTranslation();

  let description: string;
  if (source === 'order') {
    description = t('Wir befüllen Ihren Warenkorb mit den Artikeln Ihrer Bestellung. Dies kann je nach Anzahl einen Moment dauern.');
  } else if (source === 'salesorderset') {
    description = t('Wir befüllen Ihren Warenkorb mit Ihren gekauften Artikeln. Dies kann je nach Anzahl einen Moment dauern.');
  } else {
    description = t('Wir befüllen Ihren Warenkorb mit den Artikeln Ihrer Vorlage. Dies kann je nach Anzahl einen Moment dauern.');
  }

  return (
    <>
      <DialogHeader>
        <DialogTitle className={'flex items-center'}>{t('Artikel werden hinzugefügt')}</DialogTitle>
      </DialogHeader>
      <div>
        <LoadingIndicator />
        {description}
      </div>
    </>
  );
}
